import React from 'react';

export const Png = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '52'}
    height={height ?? '52'}
    viewBox="0 0 52 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_521_7836)">
      <path
        d="M10.8967 18.381H13.6428V21.1271H10.8967V18.381ZM47.9684 6.02383V38.9764C47.9684 41.997 45.4969 44.4685 42.4763 44.4685H9.52372C6.50307 44.4685 4.03163 41.997 4.03163 38.9764V6.02383C4.03163 3.00318 6.50307 0.531738 9.52372 0.531738H42.4763C45.4969 0.531738 47.9684 3.00318 47.9684 6.02383ZM17.7619 18.381C17.7619 16.1018 15.922 14.262 13.6428 14.262H6.77768V30.7383H10.8967V25.2462H13.6428C15.922 25.2462 17.7619 23.4063 17.7619 21.1271V18.381ZM31.4921 14.262H27.373V21.1271L24.627 14.262H20.5079V30.7383H24.627V23.8731L27.373 30.7383H31.4921V14.262ZM45.2223 17.9142C45.2223 16.1018 43.7669 14.262 41.5701 14.262H37.8904C35.6935 14.262 34.2381 16.1018 34.2381 17.9142V27.086C34.2381 28.8984 35.6935 30.7383 37.8904 30.7383H41.5701C43.7669 30.7383 45.2223 28.8984 45.2223 27.086V22.5001H41.1033V26.6192H38.3572V18.381H45.2223V17.9142Z"
        fill="#615E84"
      />
      <path
        d="M6.77768 13.762H6.27768V14.262V30.7383V31.2383H6.77768H10.8967H11.3967V30.7383V25.7462H13.6428C16.1982 25.7462 18.2619 23.6824 18.2619 21.1271V18.381C18.2619 15.8257 16.1982 13.762 13.6428 13.762H6.77768ZM31.9921 14.262V13.762H31.4921H27.373H26.873V14.262V18.5308L25.0912 14.0763L24.9655 13.762H24.627H20.5079H20.0079V14.262V30.7383V31.2383H20.5079H24.627H25.127V30.7383V26.4694L26.9088 30.9239L27.0345 31.2383H27.373H31.4921H31.9921V30.7383V14.262ZM45.7223 22.5001V22.0001H45.2223H41.1033H40.6033V22.5001V26.1192H38.8572V18.881H45.2223H45.7223V18.381V17.9142C45.7223 15.8605 44.0766 13.762 41.5701 13.762H37.8904C35.3839 13.762 33.7381 15.8605 33.7381 17.9142V27.086C33.7381 29.1397 35.3839 31.2383 37.8904 31.2383H41.5701C44.0766 31.2383 45.7223 29.1397 45.7223 27.086V22.5001ZM11.3967 18.881H13.1428V20.6271H11.3967V18.881ZM47.4684 6.02383V38.9764C47.4684 41.7209 45.2208 43.9685 42.4763 43.9685H9.52372C6.77922 43.9685 4.53163 41.7209 4.53163 38.9764V6.02383C4.53163 3.27932 6.77922 1.03174 9.52372 1.03174H42.4763C45.2208 1.03174 47.4684 3.27932 47.4684 6.02383Z"
        stroke="black"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_521_7836"
        x="0.0316315"
        y="0.531738"
        width="51.9368"
        height="51.9368"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_521_7836"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_521_7836"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
